export const normalizeTagSequence = (
  sequence,
  fallbackSequence = Number.MAX_SAFE_INTEGER
) => {
  const parsedSequence = Number(sequence);

  if (!Number.isInteger(parsedSequence) || parsedSequence < 1) {
    return fallbackSequence;
  }

  return parsedSequence;
};

export const sortTagsBySequence = (tags = []) =>
  [...tags].sort((firstTag, secondTag) => {
    const sequenceDifference =
      normalizeTagSequence(firstTag?.sequence) -
      normalizeTagSequence(secondTag?.sequence);

    if (sequenceDifference !== 0) {
      return sequenceDifference;
    }

    return (firstTag?.english ?? '').localeCompare(secondTag?.english ?? '');
  });

export const getOrderedTagTitles = (tags = []) =>
  sortTagsBySequence(tags)
    .map((tag) => {
      if (typeof tag === 'string') {
        return tag;
      }

      return tag?.english ?? tag?.title ?? '';
    })
    .filter(Boolean);
